import { StructuredPacking } from '../interfaces/medicine';

export const SOLID_MEDICINE_UNITS = [
  'po',
  'granulado',
  'capsula',
  'comprimido',
  'pastilha',
  'ovulo',
  'supositorio',
  'adesivo transdermico',
];

export const DEFAULT_FRACTIONATED_UNIT: StructuredPacking = {
  TipoEmbalagem: 'Unidade',
  VolumeEmbalagem: 1,
  UnidadeVolumeEmbalagem: 'un.',
  LabelEmbalagem: 'Unidades Fracionadas',
  Embalagem: '1',
  QuantidadeEmbalagens: 1,
  PreSelecionado: false,
};

export const POSOLOGY_MAX_LENGTH = 250;

export const RECURRENCE_DISABLED_MESSAGE = 'Renovações Agendadas indisponíveis para este tipo de medicamento';
export const RECURRENCE_DISABLED_REASON_ID = 'recurrence-disabled-reason';

export enum TipoAntimicrobianoEnum {
  GLP1 = 4,
}

export enum TotalTreatmentEnum {
  INDEFINIDO = 'indefinido',
}
